/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import ReactIdSwiper from 'react-id-swiper';
import { Swiper } from 'swiper/dist/js/swiper.esm';
import Fade from 'react-reveal/Fade';

import { ModalLink as Link } from 'react-router-modal-gallery';
import DataLayer from '~/components/DataLayer';
import Thumbnail from '~/components/Thumbnail/Thumbnail';
import Arrow from '../Arrow/Arrow';

export const Features = React.forwardRef(({
	className,
	classes,
	mobile,
	text,
	list,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const titleRef = React.useRef();
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [swiperThumbsRef, setSwiperThumbsRef] = React.useState(null);

	const swiperThumbsConfigDesktop = {
		Swiper,
		getSwiper: setSwiperThumbsRef,
		direction: 'horizontal',
		centerInsufficientSlides: true,
		loopFillGroupWithBlank: true,
		loop: false,
		freeMode: false,
		grabCursor: true,
		centeredSlides: false,
		initialSlide: currentIndex,
		slidesPerGroup: 2,
		slidesPerView: 3,
		slidesPerColumn: 1,
		spaceBetween: 15,
	};

	const swiperThumbsConfigTablet = {
		...swiperThumbsConfigDesktop,
		centeredSlides: false,
		slidesPerView: 2.5,
		slidesPerGroup: 2,
		slidesPerColumn: 1,
		spaceBetween: 18,
		cssMode: true,
	};

	const swiperThumbsConfigSmartphone = {
		...swiperThumbsConfigDesktop,
		centeredSlides: false,
		slidesPerView: 2,
		slidesPerGroup: 2,
		slidesPerColumn: 1,
		spaceBetween: 20,
		cssMode: true,
	};

	const nextSlide = React.useCallback((index, speed, runCallbacks, internal) => {
		if (swiperThumbsRef) swiperThumbsRef.slideNext(speed);
	}, [swiperThumbsRef]);

	const prevSlide = React.useCallback((index, speed, runCallbacks, internal) => {
		if (swiperThumbsRef) swiperThumbsRef.slidePrev(speed);
	}, [swiperThumbsRef]);

	const onChange = React.useCallback(() => {
		if (swiperThumbsRef) setCurrentIndex(swiperThumbsRef.realIndex);
	}, []);

	const onResize = React.useCallback(() => {
		if (swiperThumbsRef) {
			swiperThumbsRef.update();
		}
	}, [swiperThumbsRef]);

	const toggleEvents = (type) => {
		if (swiperThumbsRef && swiperThumbsRef.eventsListeners) {
			swiperThumbsRef[type]('slideChange', onChange);
			swiperThumbsRef[type]('resize', onResize);
		}
	};

	const renderThumbnailPicture = (sources, index) => {
		console.info(
			'We have to implements the custom `Picture` component to accept the object %o ' +
			'from `data-covers.features[%i].thumb` at `MainPage/Features` component', sources, index
		);
		return null;
	};

	const renderThumbnailImg = (item, index, length) => {
		if (index === length) onResize();
		return (
			<Thumbnail
				className={cls(classes.thumbImage)}
				caption={item.title}
				img={item.thumb}
				disabled={false}
				visible={true}
			/>
		);
	};

	const renderItem = (item, index, { length }) => {
		return (
			<div key={index} className={cls(classes.thumbItem)}>
				<DataLayer onEvent={'MainPage_ClicouThumbnail'} args={[item.path]}>
					<Link
						className={cls(classes.thumbLink)}
						to={{
							pathname: item.path,
							state: { feature: item, mobile },
						}}>
						{item.thumb.sources
							? renderThumbnailPicture(item, index, length - 1)
							: renderThumbnailImg(item, index, length - 1)
						}
					</Link>
				</DataLayer>
			</div>
		);
	};

	const renderList = (list) => {
		return list.map(renderItem);
	};

	React.useEffect(() => {
		toggleEvents('on');
		return () => toggleEvents('off');
	}, [swiperThumbsRef]);

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
		title: titleRef.current,
		update: onResize,
		nextSlide,
		prevSlide,
	}));

	return (

		<section
			ref={rootRef}
			{...props}
			className={cls(classes.root, className)}>
			<header className={classes.header}>
				<p
					ref={titleRef}
					className={cls(classes.headerText)}
					dangerouslySetInnerHTML={{
						__html: text,
					}}
				/>
			</header>

			<Fade>
				<div className={cls(classes.thumb)}>
					<ReactIdSwiper
						containerClass={cls(classes.thumbList)}
						{...swiperThumbsConfigDesktop}
						breakpoints={{
							568: {
								...swiperThumbsConfigSmartphone,
							},
							768: {
								...swiperThumbsConfigSmartphone,
							},
							1023: {
								...swiperThumbsConfigTablet,
							},
						}}
						>
						{renderList(list)}
					</ReactIdSwiper>
				</div>
			</Fade>
			{!mobile && (
				<Fade>
					<div className={cls(classes.thumbControl)}>
						<DataLayer onEvent={'MainPage_ClicouProximo'} args={[currentIndex]}>
							<Arrow
								className={cls(classes.thumbControlNext)}
								onClick={nextSlide}
							/>
						</DataLayer>
						<DataLayer onEvent={'MainPage_ClicouAnterior'} args={[currentIndex]}>
							<Arrow
								className={cls(classes.thumbControlPrev)}
								onClick={prevSlide}
							/>
						</DataLayer>
					</div>
				</Fade>
			)}
		</section>

	);
});

export default React.memo(Features);
